// Epoch 19: Lead Generator Enhancements - Filter Summary Component
// File: src/components/filters/FilterSummary.tsx
// Purpose: Display summary of applied filters with clear all action

import React from 'react';
import { FilterSummaryProps } from '../../types/filters';

export default function FilterSummary({ filters, onClearAll }: FilterSummaryProps) {
  // Calculate total applied filters
  const getTotalFilterCount = () => {
    let count = 0;
    count += filters.countries.length;
    count += filters.cities.length;
    count += filters.jobLevels.length;
    count += filters.jobFunctions.length;
    count += filters.industries.length;
    count += (5 - filters.tiers.length); // Count deselected tiers
    return count;
  };

  const totalCount = getTotalFilterCount();
  const hasFilters = totalCount > 0;

  if (!hasFilters) {
    return (
      <div className="text-sm text-gray-500">
        No filters applied
      </div>
    );
  }

  return (
    <div className="flex items-center justify-between">
      <div className="text-sm">
        <span className="font-medium text-gray-900">{totalCount}</span>
        <span className="text-gray-600 ml-1">
          {totalCount === 1 ? 'filter applied' : 'filters applied'}
        </span>
      </div>
      <button
        onClick={onClearAll}
        className="text-sm text-blue-600 hover:text-blue-800 font-medium"
      >
        Clear All
      </button>
    </div>
  );
}